/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    bug: {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M4.355.522a.5.5 0 01.623.333l.291.956A5 5 0 018 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 11.957.29l-.41 1.352A5 5 0 0113 6h.5a.5.5 0 00.5-.5V5a.5.5 0 011 0v.5A1.5 1.5 0 0113.5 7H13v1h1.5a.5.5 0 010 1H13v1h.5a1.5 1.5 0 011.5 1.5v.5a.5.5 0 11-1 0v-.5a.5.5 0 00-.5-.5H13a5 5 0 01-10 0h-.5a.5.5 0 00-.5.5v.5a.5.5 0 11-1 0v-.5A1.5 1.5 0 012.5 10H3V9H1.5a.5.5 0 010-1H3V7h-.5A1.5 1.5 0 011 5.5V5a.5.5 0 011 0v.5a.5.5 0 00.5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 01.333-.623M4 7v4a4 4 0 003.5 3.97V7zm4.5 0v7.97A4 4 0 0012 11V7zM12 6a4 4 0 00-1.334-2.982A3.98 3.98 0 008 2a3.98 3.98 0 00-2.667 1.018A4 4 0 004 6z"/>',
    },
});
